import React, {useEffect, useState} from "react";
import TopBoxV2 from "../common/TopBoxV2";
import PageNameV2 from "../common/PageNameV2";
import PageTitleV2 from "../common/PageTitleV2";
import ShopSelectBoxV2 from "../common/ShopSelectBoxV2";
import {useOptionGrp2} from "../../../static/js/hock/optionHock";
import OptionGrpPopupV2 from "./OptionGrpPopupV2";
import {formatCost, openPopup} from "../../../static/js/Common2";
import {
  getOptionGrpDetail,
  getOptionList, optionGrpStatusChange,
  optionStatusChangeApi
} from "../../../static/js/service/optionService";
import {subNavEvent} from "../../../static/js/service/commonService";
import {useShopAdminDetail2} from "../../../static/js/hock/shopHock";
import {menuGrpStatusChange} from "../../../static/js/service/menuService";

export default function OptionListV2() {
  let [shopList, setShopList] = useState([]);
  let [shopId, setShopId] = useState();
  let [optionGrpList, setOptionGrpList] = useState([]);
  const [reset, setReset] = useState(false);
  const [approvalTpcd1, setApprovalTpcd1] = useState();

  useOptionGrp2({setOptionGrpList}, shopId);
  useShopAdminDetail2({setApprovalTpcd1}, shopId);


  useEffect(() => {
    function handleClickOutside(e) {
      let menuSelect = document.querySelectorAll(`.menuSelect`);
      menuSelect.forEach((element) => {
        element.classList.remove("active");
      })

      if(e.target.classList.contains("menuSelectText")) {
        let dataId = e.target.getAttribute("data-id");
        document.getElementById(`menuSelect${dataId}`).classList.add("active");
      }
    }

    // document에 클릭 이벤트 리스너 추가
    document.addEventListener('click', handleClickOutside);

    const targetId = sessionStorage.getItem("targetId");

    if(targetId) {
      const targetElement = document.getElementById(targetId);
      if (targetElement) {
        targetElement.scrollIntoView({
          behavior: 'auto',
          block: 'start'
        });
        sessionStorage.removeItem("targetId");
      }
    }

    subNavEvent("menuNav", "menu2");
  }, [optionGrpList]);

  function optionGrpDetail(grpId) {
    getOptionGrpDetail(grpId).then((response) => {
      let grpData = response[0];

      document.getElementById("optionGrpIndex").value = grpId;
      document.getElementById("optionGrpNameInput2").value = grpData.optGrpName;
      document.getElementById("optionGrpStates2").setAttribute("data-id", grpData.essChoiceSta)
      document.querySelector("#optionGrpStates2 .selectText").innerText = grpData.essChoiceSta === 1 ? "필수" : "선택";
      document.getElementById("maxNumber2").value = grpData.maxChoiceCnt;
      document.getElementById("maxBtnBox2").classList.remove("hide");

      document.querySelector("#maxBtnBox2 .flexTitle").innerText =
        grpData.essChoiceSta === 1 ? '선택 갯수' : '최대 선택갯수';
      
      // if(grpData.essChoiceSta === 1) {
      //   document.getElementById("maxBtnBox2").classList.add("hide");
      // } else {
      //   document.getElementById("maxBtnBox2").classList.remove("hide");
      // }

      getOptionList(grpId).then((response) => {
        let optionList = response;

        if(optionList.length !== 0) {
          optionList.sort(function(a, b) {
            return parseFloat(a.exposSeq) - parseFloat(b.exposSeq)
          })

          let optionBox = document.querySelector("#newOptionList2");
          optionBox.innerHTML = "";

          optionList.map((value, index) => {
            let div = document.createElement("div");
            if(index === 0) {
              div.innerHTML = `<input type='text' class='newOptionName'  value="${value.optName}" name='newOptionName' placeholder='옵션명' />` +
                `<input type='number' class='newOptionPrice priceCut100' value="${value.optCost}" name='newOptionPrice' /> 원`
            } else {
              div.innerHTML = `<input type='text' class='newOptionName' value="${value.optName}" name='newOptionName' placeholder='옵션명' />` +
                `<input type='number' class='newOptionPrice priceCut100' value="${value.optCost}" name='newOptionPrice' /> 원` +
                `<button type='button' class='newOptionRemoveBtn'>삭제</button>`
            }

            div.setAttribute("class", 'newOptionBox addNewOption modifyNewOption');
            div.setAttribute("data-id", value.id);
            div.setAttribute("data-type", value.productTpcd)
            div.lastChild.addEventListener("click", () => {
              div.setAttribute("class", 'newOptionBox modifyNewOption hide')
            });

            div.querySelector(".newOptionPrice").addEventListener("change", (e) => {
              let n = e.target.value;

              if(n < 0) {
                alert('0원 이상 입력가능합니다.')
                e.target.value = 0
              }
            })

            optionBox.appendChild(div);
          })
        }
      })
    })

    openPopup("optionSetPopup");
  }

  function optionChange(id, grpId, status) {
    let optionList = [];
    let optionType = false;

    optionGrpList.forEach((value) => {
      if(value.id === grpId) {
        optionType = value.requiredChoice;
        optionList = value.optionList;
      }
    })

    let first = true;
    if(!optionType) {
      first = false;
    }

    if(optionList.length > 0) {
      optionList.forEach((value) => {
        if(value.id === id) {
          value.status = status;
        }
        value.selected = false;

        if(first && value.status === 1) {
          value.selected = true;
          first = false;
        }
      });
    }

    optionStatusChangeApi(shopId, grpId, id, status, optionList)
  }

  const menuGrpStatusEvent = async (e, id) => {
    if (!menuGrpStatusEvent.isRunning) {
      menuGrpStatusEvent.isRunning = true;

      let isChecked = e.currentTarget.querySelector(".toggleInput").checked;
      await optionGrpStatusChange(shopId, id, isChecked);

      setTimeout(() => {
        menuGrpStatusEvent.isRunning = false;
      }, 1000); // 중복 실행 방지를 위한 시간 설정 (1초)
    }
  }

  let optionGrpBox = optionGrpList.map((value, index) => {
    return (
      <div id={`menuListBox${value.id}`} className={`menuListBox menuListBox${value.id}`} key={value.id}>
        <div className="optionGrpBox">
          <div className="textBox">
            <h3 className="menuGrpName" onClick={() => optionGrpDetail(value.id)}>{value.name}</h3>
            {/* 그룹 토글 및 버튼 */}
            <div className={`menuToggle ${value.isVisible ? "active" : ""}`} >
              <label className="toggleSwitch" onClick={(e) => menuGrpStatusEvent(e, value.id)}>
                <input type="checkbox" className="toggleInput" defaultChecked={value.isVisible} hidden />
                <span className="toggleBtn"></span>
              </label>
              <span className={`toggleStates ${!value.isVisible ? "gray" : ""}`}>
              {value.isVisible ? "전체 노출" : "미노출"}
            </span>
            </div>
          </div>
        </div>
        <div>
          <div className="optionFlexBox optionFlexBox0">
            <div className="optionChoiceBox flexBox">
              <h4>필수 여부</h4>
              <p>{value.requiredChoice ? "필수" : "선택"}</p>
            </div>
            <div className="optionCountBox flexBox">
              <h4>{value.requiredChoice ? '선택 갯수' : '최대 선택갯수'}</h4>
              <p>{value.maxChoiceCount}</p>
            </div>
          </div>
          <div className="optionFlexBox">
            <div className="optionInfoBox flexBox">
              <h4>옵션 내용</h4>
              <div>
                {value.optionList.map((data) => {
                  let productTpcd = Number(data.status);
                  let status = "판매";
                  if(productTpcd === 3) {
                    status = '품절';
                  } else if(productTpcd === 2) {
                    status = '판매 중지';
                  }

                  return (
                    <div key={data.id} className="flexBox">
                      <p className="optName">{data.name}</p>
                      <p className='optCost'>+{formatCost(data.cost)}</p>원
                      <div id={`menuSelect${data.id}`} className={`menuSelect menuSelect${data.id}`}>
                        <div className={`${productTpcd === 1 ? "menuSelectText" : "menuSelectText red"}`} data-id={data.id}>
                          {status}
                        </div>
                        <ul className='menuSelectOptionList' style={{zIndex: 200 - index}}>
                          <li data-states={1} onClick={() => optionChange(data.id, value.id, 1)}>판매</li>
                          <li data-states={2} className='red' onClick={() => optionChange(data.id, value.id, 2)}>판매중지</li>
                          <li data-states={3} className='red' onClick={() => optionChange(data.id, value.id, 3)}>품절</li>
                        </ul>
                      </div>
                    </div>
                  )
                })}
              </div>
            </div>
          </div>
        </div>
      </div>
    )
  })

  return (
    <main id="menuListV2" className="mainV2">
      <TopBoxV2 shopList={shopList} />
      <OptionGrpPopupV2 shopId={shopId} optionGrpList={optionGrpList} reset={reset} setReset={setReset} />

      <div className="container">
        <section id="shopSec1" className="containerInner">
          <PageNameV2 title1="메뉴 관리" title2="옵션 관리" />
          <div className="pageTitle mb-10 d-flex a-center j-between">
            <PageTitleV2 title="옵션 관리" countText="" count="" unit="" />
          </div>
          <div className="topMenu">
            <div id="shopSelectBox">
              <ShopSelectBoxV2 url="/v2/optionList" setShopId={setShopId} setShopList={setShopList} />
            </div>
            {approvalTpcd1 === 4 &&
              <div className="menuListBtn">
                <button className="commonBtn blueBtn openBtn" onClick={() => openPopup("optionAddPopup")}>옵션 그룹 추가</button>
                <button className="commonBtn blueBtn openBtn marginLeft5" onClick={() => openPopup("menuPopup3")}>옵션 순서변경</button>
                <button className="commonBtn blueBtn openBtn marginLeft5" onClick={() => openPopup("menuGrpPopup2")}>옵션 그룹 순서변경</button>
                <button className="commonBtn blueBtn openBtn marginLeft5" onClick={() => openPopup("menuRemovePopup1")}>옵션 그룹 삭제</button>
              </div>
            }
          </div>

          {optionGrpBox}

        </section>
      </div>
    </main>
  )
}